module.exports = __webpack_public_path__ + "img/member.d24364e0.svg";